/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Notes_IncompleteInputs */

const en_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event has notes marked as incomplete.`)
};

const fr_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evenement a des notes marquees comme incompletes.`)
};

const de_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisnotizen sind als unvollständig gekennzeichnet.`)
};

const it_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evento ha note contrassegnate come incomplete.`)
};

const ru_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В описании мероприятия есть пометки, отмеченные как неполные.`)
};

const es_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento tiene notas marcadas como incompletas.`)
};

const zh_cn2_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动记录标记为不完整。`)
};

const ja_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントには未完了としてマークされたメモがあります。`)
};

const hi_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इवेंट के नोट्स अधूरे के रूप में चिह्नित हैं।`)
};

const pt_pt2_error_nav_notes_incomplete = /** @type {(inputs: Error_Nav_Notes_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento possui anotações marcadas como incompletas.`)
};

/**
* | output |
* | --- |
* | "Event has notes marked as incomplete." |
*
* @param {Error_Nav_Notes_IncompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_notes_incomplete = /** @type {((inputs?: Error_Nav_Notes_IncompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Notes_IncompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_notes_incomplete(inputs)
	if (locale === "de") return de_error_nav_notes_incomplete(inputs)
	if (locale === "it") return it_error_nav_notes_incomplete(inputs)
	if (locale === "ru") return ru_error_nav_notes_incomplete(inputs)
	if (locale === "es") return es_error_nav_notes_incomplete(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_notes_incomplete(inputs)
	if (locale === "ja") return ja_error_nav_notes_incomplete(inputs)
	if (locale === "hi") return hi_error_nav_notes_incomplete(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_notes_incomplete(inputs)
	return en_error_nav_notes_incomplete(inputs)
});